<section class="quick-actions">
  <header class="quick-actions__header">
    <h2 class="quick-actions__title">{{ 'quickActions.title' | t }}</h2>
  </header>

  <div class="quick-actions__grid">
    @for (action of actionItems(); track action.id) {
      @if (!action.hidden) {
        <button type="button" class="quick-actions__button" [attr.data-track]="action.id === 'callback' ? 'quick_contact' : 'quick_document_upload'" (click)="triggerAction(action.id)">
          <span>{{ action.label }}</span>
          <span class="quick-actions__icon far fa-long-arrow-right" aria-hidden="true"></span>
        </button>
      }
    }
  </div>
</section>
